import { useState, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import Notices from './Notices';
import Timeline from './Timeline';
import BasicTabs from '../../common/BasicTabs';
import { selectUser } from '../../../features/auth/authSlice';

const Information = () => {
  const user = useSelector(selectUser);
  const [value, setValue] = useState(0);

  const tabs = useMemo(() => {
    let tabArray = [
      {
        label: 'Notices',
        component: <Notices />,
      },
    ];

    if (user.type !== 'Developer' && user.type !== 'Marketing') {
      tabArray.push({
        label: 'Change Log',
        component: <Timeline />,
      });
    }

    return tabArray;
  }, []);

  return (
    <Box
      sx={{
        p: 2,
        height: '100vh',
        position: 'relative',
      }}
    >
      <Typography variant="h5" sx={{ alignSelf: 'center', mb: 2 }}>
        <strong>Information</strong>
      </Typography>
      <BasicTabs tabs={tabs} sub={true} value={value} setValue={setValue} color={'#fff'} />
    </Box>
  );
};

export default Information;
